import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-fund-options',
  templateUrl: './fund-options.component.html',
  styleUrls: ['./fund-options.component.scss']
})

export class FundOptionsComponent implements OnInit {
  public instantPaymentTooltip = '';
  public StandardBankTransferTooltip = '';
  isPrivalgoMarkets = !environment.isPrivalgoMarkets;
  brandName = environment.brandName;
  constructor(
    public dialogRef: MatDialogRef<FundOptionsComponent>
  ) {}

  ngOnInit() {
    this.instantPaymentTooltip = `You will be directed to your online banking service to instruct your payment to ${this.brandName}.\n`
                                 + '(This service utilises open banking technology provided via Token.IO)';
    this.StandardBankTransferTooltip = `You will need to manually instruct payment to ${this.brandName}.`;
  }

  buttonClicked(buttonId: any) {
    this.dialogRef.close(buttonId);
  }
}
